import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { PeekGrid } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useAnalytics } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import AppHeader from "@components/app-header";
import { USER_ROLES } from "@constants/Roles";
export const HomeLayout = () => {
    var _a;
    const analytics = useAnalytics();
    const { user } = useAuthContext();
    useEffect(() => {
        var _a;
        analytics.page({
            title: `Peek Dashboard || Home || ${((_a = user === null || user === void 0 ? void 0 : user.organization) === null || _a === void 0 ? void 0 : _a.name) || (user === null || user === void 0 ? void 0 : user.name)}`,
        });
    }, []);
    return (React.createElement(PeekGrid, { container: true },
        user.roleId !== USER_ROLES.Owner && (React.createElement(PeekGrid, { item: true, xs: 12, py: 4 },
            React.createElement(AppHeader, { headerLabel: (_a = user === null || user === void 0 ? void 0 : user.organizations[0]) === null || _a === void 0 ? void 0 : _a.name }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, null)))));
};
export default HomeLayout;
